import React, {useContext} from 'react'
import {ReactComponent as LoopIcon} from '@shop/icon-fonts/optimized/loop-mid.svg'
import Link from '../Link'
import Account from '../Account'
import {DEVICE_TYPES, LinkSeparator} from '../../utils'
import {SecondaryIcon} from '../Icon/Icon.styled'
import AppContext from '../../context'
import {Text, TopBar} from './TopBar.styled'
import Multilanguage from '../Multilanguage'
import {SHIPPING_FEE_TEXT_ID} from '../../utils/constants'
import ExternalComponent from '../Injected'

export const HELP_ID = 'srh-help'
export const REORDER_ID = 'srh-reorder'

const TopBarComponent = () => {
  const {hasReorder, reorderLink, helpLink, translations, device, multilanguage, viaWebC, shippingFeeURL} = useContext(AppContext)
  const isMobile = device === DEVICE_TYPES.SMARTPHONE || device === DEVICE_TYPES.PHABLET

  const TopBarText = <Text>
    <ExternalComponent
      id={SHIPPING_FEE_TEXT_ID}
      viaWebC={viaWebC}
      url={shippingFeeURL}
    />
  </Text>

  const separator = <LinkSeparator />
  const help = <Link id={HELP_ID} href={helpLink} target="_blank" noWrap>
    {translations.get('shop.header.top.help')}
  </Link>;
  /* TODO: There should be a way to abstract the class name - need to investigate */
  const reorder = hasReorder
    && <Link id={REORDER_ID} type="secondary" href={reorderLink} className="iconRight" noWrap>
      {translations.get('shop.header.top.reorder')}
      <SecondaryIcon>
        <LoopIcon />
      </SecondaryIcon>
    </Link>;

  const leftSectionTopBar = <>
    {multilanguage && <Multilanguage />}
    {multilanguage ? separator : null}
    </>
  const rightSectionTopBar = <>
    {help}
    {help ? separator : null}
    {reorder}
    {reorder ? separator : null}
    {<Account />}
  </>

  return (
    <TopBar>
      {!isMobile && leftSectionTopBar}
      {TopBarText}
      {!isMobile && rightSectionTopBar}
    </TopBar>
  )
}

export default TopBarComponent
